import { useResponsive } from '../../hooks/useResponsive';
import ConsentDesktop from './ConsentDesktop';
import ConsentMobile from './ConsentMobile';
import { useConsent } from './useConsent';

const Consent = () => {
  const breakpointIndex = useResponsive([768]);
  const props = useConsent();

  if (breakpointIndex === 0) {
    return <ConsentMobile {...props} />;
  }
  return <ConsentDesktop {...props} />;
};

export default Consent;
